import { shape, string, oneOf } from 'prop-types';

export const userContract = shape({
  UserEmail: string.isRequired,
  UserName: string.isRequired,
  UserId: string.isRequired,
  UserRole: oneOf(['Admin', 'User']),
  CurrentExerciseId: string,
  PartyId: string
});
